import {AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2} from '@angular/core';

@Directive({
  selector: 'button'
})
export class ButtonTextMatchDirective implements AfterViewInit, OnDestroy {
  matchTexts: string[] = ['Okay', 'Save', 'Finish', 'Next', 'Accept', 'Accept All', 'Reprocess', 'Process']; // Fixed Words
  targetClass = 'global-theme-btn';
  targetContainers: string[] = ['.dialog-button-container', '.button-container', '.global-container']; // Default containers to target
  private observer: MutationObserver;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngAfterViewInit() {
    // Check if the button is inside a desired container (e.g., dialog or form container)
    const containerSelector = this.targetContainers.join(',');
    const isInTargetContainer = this.el.nativeElement.closest(containerSelector);
    if (isInTargetContainer && !this.el.nativeElement.disabled) {
      this.applyClassBasedOnText();
    }

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {

          if (this.el.nativeElement.disabled) {
            // If button is disabled, remove the class
            this.removeClass();
          }
          else {
            // If button is enabled, apply (add/remove) class based on button text
            this.applyClassBasedOnText();
          }
        }
      });
    });
    this.observer.observe(this.el.nativeElement, {attributes: true});
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private applyClassBasedOnText() {
    const buttonText = this.el.nativeElement.textContent.trim();
    const isTextMatched = this.matchTexts.some(text => buttonText.toLowerCase().includes(text.toLowerCase()));

    if (isTextMatched) {
      this.addClass();
    }
    else {
      this.removeClass();
    }
  }

  private addClass(): void {
    this.renderer.addClass(this.el.nativeElement, this.targetClass);
  }

  private removeClass(): void {
    this.renderer.removeClass(this.el.nativeElement, this.targetClass);
  }

}
